<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4 class="p-d-flex p-ai-baseline">
                    <router-link icon="pi pi-angle-left" class="p-button p-button-icon p-mr-4" v-if="client && client.key" :to="{ name: 'sites', params: { id: client.key } }">
                        <i class="pi pi-angle-left"></i>
                        Back
                    </router-link>
                    <span>
                        <router-link v-if="client && client.key" :to="{ name: 'sites', params: { id: client.key } }">{{
                            client.name
                        }}</router-link> /
                        {{ site.name }}
                    </span>
                </h4>
                <div class="p-grid p-mt-2 p-mb-6">
                    <div style="flex-grow: 1;">
                        <ValidationObserver v-slot="{ handleSubmit }" slim ref="info">
                            <div @submit.prevent="handleSubmit(saveSite())">

                                <ul class="site-details">
                                    <li>
                                        <span>Site Name</span>
                                        <span v-if="editSite == false">{{ site.name }}</span>
                                        <ValidationProvider v-else name="Site name" :rules="{ required: true }" v-slot="{ errors }">
                                            <div class="field">
                                                <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" placeholder="Enter site name" v-model="info.name" />
                                                <small id="" class="p-error p-d-block" v-if="errors[0]">{{
                                                    errors[0]
                                                }}</small>
                                            </div>
                                        </ValidationProvider>
                                    </li>
                                    <li>
                                        <span>Site Contact</span>
                                        <span v-if="editSite == false">{{ site.contact }}</span>
                                        <!-- <InputText v-else type="text" class="p-inputtext" placeholder="Enter contact name" v-model="editContact" /> -->
                                        <ValidationProvider v-else name="Contact name" v-slot="{ errors }">
                                            <div class="field">
                                                <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" placeholder="Enter contact name" v-model="info.contact" />
                                                <small id="" class="p-error p-d-block" v-if="errors[0]">{{
                                                    errors[0]
                                                }}</small>
                                            </div>
                                        </ValidationProvider>
                                    </li>
                                    <li>
                                        <span>Site Contact Mobile</span>
                                        <span v-if="editSite == false">{{ site.mobile }}</span>
                                        <ValidationProvider v-else name="Site contact mobile" :rules="{ regex: /^07/, length: 11, integer: true }" v-slot="{ errors }">
                                            <div class="field">
                                                <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" placeholder="Enter mobile number" v-mask="'###########'" v-model="info.mobile" />
                                                <small id="" class="p-error p-d-block" v-if="errors[0]">{{
                                                    errors[0]
                                                }}</small>
                                            </div>
                                        </ValidationProvider>
                                        <!-- <InputText v-else type="text" class="p-inputtext" placeholder="Enter mobile number" v-model="editMobile" /> -->
                                    </li>
                                    <li>
                                        <span>Site Address</span>
                                        <span v-if="editSite == false">{{ site.address }}</span>
                                        <ValidationProvider v-else name="Site address" v-slot="{ errors }">
                                            <div class="field">
                                                <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" placeholder="Enter postal address" v-model="info.address" />
                                                <small id="" class="p-error p-d-block" v-if="errors[0]">{{
                                                    errors[0]
                                                }}</small>
                                            </div>
                                        </ValidationProvider>
                                        <!-- <InputText v-else type="text" class="p-inputtext" placeholder="Enter postal address" v-model="editAddress" /> -->
                                    </li>
                                    <li class="p-mt-4">
                                        <span>Main Telephone</span>
                                        <span v-if="editSite == false">{{ site.main_tel }}</span>
                                        <ValidationProvider v-else name="Main telephone number" :rules="{ length: 11, integer: true }" v-slot="{ errors }">
                                            <div class="field">
                                                <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" placeholder="Enter main telephone number" v-mask="'###########'" v-model="info.mainTel" />
                                                <small id="" class="p-error p-d-block" v-if="errors[0]">{{
                                                    errors[0]
                                                }}</small>
                                            </div>
                                        </ValidationProvider>
                                        <!-- <InputText v-else type="text" class="p-inputtext" placeholder="Enter main telephone number" v-model="editMainTel" /> -->
                                    </li>
                                    <li>
                                        <span>Main Email</span>
                                        <span v-if="editSite == false">{{ site.main_email }}</span>
                                        <ValidationProvider v-else name="Main email address" :rules="{ email: true }" v-slot="{ errors }">
                                            <div class="field">
                                                <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" placeholder="Enter email address" v-model="info.mainEmail" />
                                                <small id="" class="p-error p-d-block" v-if="errors[0]">{{
                                                    errors[0]
                                                }}</small>
                                            </div>
                                        </ValidationProvider>
                                        <!-- <InputText v-else type="text" class="p-inputtext" placeholder="Enter email address" v-model="editMainEmail" /> -->
                                    </li>
                                    <li class="p-mt-4">
                                        <span>Area Contact</span>
                                        <span v-if="editSite == false">{{ site.area_contact }}</span>
                                        <ValidationProvider v-else name="Area contact name" v-slot="{ errors }">
                                            <div class="field">
                                                <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" placeholder="Enter area contact name" v-model="info.areaContact" />
                                                <small id="" class="p-error p-d-block" v-if="errors[0]">{{
                                                    errors[0]
                                                }}</small>
                                            </div>
                                        </ValidationProvider>
                                        <!-- <InputText v-else type="text" class="p-inputtext" placeholder="enter area contact name" v-model="editAreaContact" /> -->
                                    </li>
                                    <li>
                                        <span>Area Email</span>
                                        <span v-if="editSite == false">{{ site.area_email }}</span>
                                        <ValidationProvider v-else name="Area email address" :rules="{ email: true }" v-slot="{ errors }">
                                            <div class="field">
                                                <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" placeholder="Enter area email address" v-model="info.areaEmail" />
                                                <small id="" class="p-error p-d-block" v-if="errors[0]">{{
                                                    errors[0]
                                                }}</small>
                                            </div>
                                        </ValidationProvider>
                                        <!-- <InputText v-else type="text" class="p-inputtext" placeholder="Enter area email address" v-model="editAreaEmail" /> -->
                                    </li>
                                    <li>
                                        <span>Area Mobile</span>
                                        <span v-if="editSite == false">{{ site.area_mobile }}</span>
                                        <ValidationProvider v-else name="Area mobile number" :rules="{ regex: /^07/, length: 11, integer: true }" v-slot="{ errors }">
                                            <div class="field">
                                                <InputText type="text" :class="{ 'p-invalid': errors.length > 0 }" class="p-inputtext p-d-block" placeholder="Enter area mobile number" v-mask="'###########'" v-model="info.areaMobile" />
                                                <small id="" class="p-error p-d-block" v-if="errors[0]">{{
                                                    errors[0]
                                                }}</small>
                                            </div>
                                        </ValidationProvider>
                                        <!-- <InputText v-else type="text" class="p-inputtext" placeholder="Enter area mobile number" v-model="editAreaMobile" /> -->
                                    </li>
                                </ul>


                                <div class="site-actions">
                                    <div class="p-d-flex">
                                        <div v-if="(user.data.role.permissionLevel >= 4)">
                                            <Button v-if="editSite == false" label="Edit Site" icon="pi pi-pencil" @click="editSiteDetails()" />
                                            <Button v-else label="Save Site" icon="pi pi-save" @click.prevent="saveSite()" class="p-button-primary p-button" />
                                            <Button :label="copyLabel" class="p-button-link" @click="copyNFCLocation" />
                                        </div>
                                        <div v-else>
                                            <Button :label="copyLabel" class="p-button-link" @click="copyNFCLocation" />
                                        </div>
                                        <Button v-if="editSite == true && (user.data.role.permissionLevel >= 4)" label="Cancel" class="p-button-link" @click="cancelSite()" />
                                    </div>
                                </div>

                                <div class="notification-options p-d-flex p-p-3 p-ai-center p-mt-4" style="flex-wrap:wrap">
                                    <h4>Notification Preferences</h4>
                                    <div class="p-d-flex p-ai-center p-col p-flex-wrap p-mr-4" style="flex-basis:100%">
                                        <div class="p-col-6 p-d-flex p-ai-center">
                                            Fault Reporting <InputSwitch v-model="site.faultNotifications" class="p-ml-2 p-mt-1" @change="updateFaultNotifications"/>
                                        </div>
                                        <div class="p-col-6 p-d-flex p-ai-center">
                                            Maintenance Fail Reporting <InputSwitch v-model="site.failNotifications" class="p-ml-2 p-mt-1" @change="updateFailNotifications"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="p-d-flex p-col p-ai-center" style="width:100%">

                                <div class="p-col-6">
                                    <label class="p-mb-2" v-if="site.faultNotifications">Send fault notifications emails to:</label>
                                    <div class="p-d-flex p-ai-center" style="width:100%" v-if="site.faultNotifications" >
                                        <InputText v-model="site.faultEmails" class="p-col-10"/>
                                        <Button icon="pi pi-save" class="p-ml-1 p-col-1" @click="saveFaultEmails"/>
                                    </div>
                                </div>

                                <div class="p-col-6">
                                    <label class="p-mb-2" v-if="site.failNotifications">Send fail notifications emails to:</label>
                                    <div class="p-d-flex p-ai-center" style="width:100%" v-if="site.failNotifications" >
                                        <InputText v-model="site.failEmails" class="p-col-10"/>
                                        <Button icon="pi pi-save" class="p-ml-1 p-col-1" @click="saveFailEmails"/>
                                    </div>
                                </div>
                            </div>
                            </form>
                        </ValidationObserver>
                    </div>

                    <div class="site-links p-pl-0 p-pl-lg-4">
                        <router-link v-if="(user.data.role.permissionLevel > 2)" class="p-d-flex p-jc-between p-ai-center p-jc-center" :to="'/documents/' + client.key + '/' + site.key">
                            <span class="p-d-flex p-jc-between p-ai-center">
                                <i class="pi pi-file" />
                                Documents
                            </span>
                            <i class="pi pi-angle-right" />
                        </router-link>
                        <router-link v-if="(user.data.role.permissionLevel > 2)" class="p-d-flex p-jc-between p-ai-center" :to="'/certificates/' + client.key + '/' + site.key">
                            <span class="p-d-flex p-jc-between p-ai-center">
                                <i class="pi pi-thumbs-up"></i>
                                Certificates
                            </span>
                            <i class="pi pi-angle-right" />
                        </router-link>
                        <router-link class="p-d-flex p-jc-between p-ai-center" :to="'/assets/' + client.key + '/' + site.key">
                            <span class="p-d-flex p-jc-between p-ai-center">
                                <i class="pi pi-clone" />
                                Assets
                            </span>
                            <i class="pi pi-angle-right" />
                        </router-link>
                        <router-link v-if="(user.data.role.permissionLevel > 2)" class="p-d-flex p-jc-between p-ai-center" :to="'/site-activity-log/' + client.key + '/' + site.key">
                            <span class="p-d-flex p-jc-between p-ai-center">
                                <i class="pi pi-list" />
                                Site Activity Log
                            </span>
                            <i class="pi pi-angle-right" />
                        </router-link>
                        <router-link v-if="(user.data.role.permissionLevel > 2)" class="p-d-flex p-jc-between p-ai-center" :to="'/notes/' + client.key + '/' + site.key">
                            <span class="p-d-flex p-jc-between p-ai-center">
                                <i class="pi pi-pencil" />
                                Notes
                            </span>
                            <i class="pi pi-angle-right" />
                        </router-link>
                    </div>
                    <Toast />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { db } from '@/firebase';
import { ValidationProvider } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { mapGetters } from "vuex";

import { extend } from 'vee-validate';
import { required, length, email, integer, max, regex } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: (fieldName) => {
        return `Please enter your ${fieldName.toLowerCase()}`;
    }
});
extend('length', length);
extend('integer', integer);
extend('regex', regex);
extend('max', max);
extend('email', {
    ...email,
    message: 'Please enter a valid email address'
});

import { configure } from 'vee-validate';
import axios from 'axios';

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
        dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
        // ...
    }
})

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            site: {},
            client: {},
            editSite: false,
            faultNotifications: false,
            faultNotificationEmails: '',
            failNotifications: false,
            failNotificationEmails: '',
            info: {
                contact: '',
                mobile: '',
                address: '',
                mainTel: '',
                mainEmail: '',
                areaContact: '',
                areaEmail: '',
                areaMobile: '',
            },
            copyLabel: 'Copy NFC Location'
        }
    },
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: "user"
        }),
        faultEmailsPayload() {
            return this.site.faultEmails
        },
        failEmailsPayload() {
            return this.site.failEmails
        }
    },
    firestore() {
        return {
            site: db.collection('sites').doc(this.$route.params.id),
            client: db.collection('clients').doc(this.$route.params.client_id),
        }
    },
    methods: {
        updateFaultNotifications() {
            const faultNotificationUrl = `${process.env.VUE_APP_API_URL}/update-notification/site/${this.$route.params.id}/fault`;
            axios({
                method: 'post',
                url: faultNotificationUrl,
                data: {
                    'status': this.site.faultNotifications
                }
            }).then((response) => {
                this.$toast.add({ severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
            }).catch(error => {
                this.$toast.add({ severity: 'error', summary: 'Success', detail: error.data.message, life: 3000 });
            });
        },

        updateFailNotifications() {
            const failNotificationUrl = `${process.env.VUE_APP_API_URL}/update-notification/site/${this.$route.params.id}/fail`;
            axios({
                method: 'post',
                url: failNotificationUrl,
                data: {
                    'status': this.site.failNotifications
                }
            }).then((response) => {
                this.$toast.add({ severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
            }).catch(error => {
                this.$toast.add({ severity: 'error', summary: 'Success', detail: error.data.message, life: 3000 });
            });
        },

        saveFaultEmails() {
            const failNotificationUrl = `${process.env.VUE_APP_API_URL}/update-notification/site/${this.$route.params.id}/fault-emails`;
            axios({
                method: 'post',
                url: failNotificationUrl,
                data: {
                    'faultEmails': this.faultEmailsPayload
                }
            }).then((response) => {
                this.$toast.add({ severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
            }).catch(error => {
                this.$toast.add({ severity: 'error', summary: 'Success', detail: error.data.message, life: 3000 });
            });
        },

        saveFailEmails() {
            const failNotificationUrl = `${process.env.VUE_APP_API_URL}/update-notification/site/${this.$route.params.id}/fail-emails`;
            axios({
                method: 'post',
                url: failNotificationUrl,
                data: {
                    'failEmails': this.failEmailsPayload
                }
            }).then((response) => {
                this.$toast.add({ severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
            }).catch(error => {
                this.$toast.add({ severity: 'error', summary: 'Success', detail: error.data.message, life: 3000 });
            });
        },

        copyNFCLocation() {
            // success message
            this.copyLabel = 'Copied!';
            // value to copy
            let nfcLocation = window.location.origin + '/check-in-out/' + this.client.key + '/' + this.site.key;
            // copy command
            navigator.clipboard.writeText(nfcLocation);
            // reset label value
            setTimeout(function () {
                this.copyLabel = 'Copy NFC Location';
            }.bind(this), 1000);

        },
        editSiteDetails() {
            this.editSite = !this.editSite;

            if (this.editSite == true) {
                this.info.name = this.site.name;
                this.info.contact = this.site.contact;
                this.info.mobile = this.site.mobile;
                this.info.address = this.site.address;
                this.info.mainTel = this.site.main_tel;
                this.info.mainEmail = this.site.main_email;
                this.info.areaContact = this.site.area_contact;
                this.info.areaEmail = this.site.area_email;
                this.info.areaMobile = this.site.area_mobile;
                this.info.failNotifications =  this.failEmailsString;
                this.info.faultNotifications =  this.faultEmailsString;
                this.info.failEmails = this.site.failEmails;
                this.info.faultEmails = this.site.faultEmails;
            }
        },
        cancelSite() {
            this.editSite = !this.editSite;
        },
        toggleMenu(event, data) {
            this.overlayMenuItems = {};
            this.overlayMenuItems = {
                id: data.key,
                items: [
                    {
                        label: 'View/Edit',
                        icon: 'pi pi-pencil',
                        to: { name: 'asset', params: { id: data.key, template_id: data.template_id } }
                    },
                    {
                        label: 'Delete',
                        icon: 'pi pi-trash',
                        command: (event) => {
                            this.openConfirmation(event, data.key)
                        }
                    },
                ]
            }
            this.$refs.menu.toggle(event);
        },
        saveSite() {
            // console.log(this.$refs.info);
            this.$refs.info.validate().then(success => {
                if (success) {
                    this.$firestore.site.update({
                        'name': this.info.name,
                        'contact': this.info.contact,
                        'mobile': this.info.mobile,
                        'address': this.info.address,
                        'main_tel': this.info.mainTel,
                        'main_email': this.info.mainEmail,
                        'area_contact': this.info.areaContact,
                        'area_email': this.info.areaEmail,
                        'area_mobile': this.info.areaMobile,
                    }).then(() => {
                        this.editName = '';
                        this.editSite = false;

                        db.collection('logs').add({
                            activity: 'Site details updated',
                            timestamp: new Date(),
                            user: this.user.data.email,
                            client_id: this.user.data.client.key,
                            site: this.site.name
                        }).then(() => {
                            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Site details updated', life: 3000 });
                        });
                    });
                }
            });

        }

    }
}
</script>

<style scoped lang="scss">
.site-details {
    padding: 1rem;
    list-style: none;
    margin: 0;

    li {
        @media (max-width: 991px) {
            span {
                display: block;
            }

            span:nth-child(1) {
                font-weight: bold;
            }
        }

        @media (min-width: 991px) {
            display: flex;
            justify-content: space-between;
            position: relative;

            &:before {
                content: "";
                display: block;
                width: 100%;
                height: 1px;
                background: #e9ecef;
                position: absolute;
                top: 1.7rem;
                left: 0;
                z-index: 1;
            }
        }

        span,
        input {
            position: relative;
            z-index: 2;
            background: #fff;
        }

        span {
            font-size: 1.3rem;
            line-height: 2.5rem;
            overflow-wrap: break-word;
        }

        span:nth-child(1) {
            padding-right: 1rem;
        }

        span:nth-child(2) {
            padding-left: 1rem;
            width: 50%;
        }

        .field {
            width: 100%;

            input {
                width: 100%;
            }

        }
    }
}
</style>
